export default "__VITE_ASSET__CO0LyvB3__"